import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import ViewConstants from 'constants/ViewConstants';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- entities
import { RestaurantMenu, ProductCategory } from 'PMT/entities/menu';

// -- views
import SortableList from 'PMT/components/SortableList';
import ImageLoader from 'PMT/components/ImageLoader';

class CategoryRow extends Component {

  static propTypes = {
    category: PropTypes.instanceOf(ProductCategory).isRequired,

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu).isRequired,

    // parameters ProductCategory
    onDeleteCategoryFromRoot: PropTypes.func.isRequired,
  };

  static defaultProps = {
    hideDeactivatedProducts: true
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.category.equals(this.props.category)
    || !nextProps.restaurantMenu.equals(this.props.restaurantMenu);
  }

  onDeleteCategoryFromRoot = () => {
    this.props.onDeleteCategoryFromRoot(this.props.category);
  };

  onUpCategory = () => {
    this.props.onMoveUpCategory(this.props.category);
  };

  onDownCategory = () => {
    this.props.onMoveDownCategory(this.props.category);
  };

  onDisplayDetail = () => {
    RouteAction.presentCategoryDetail(this.props.category);
  };

  renderImage() {
    const category:ProductCategory = this.props.category;

    return (
      <ImageLoader
        className="category_row__image"
        src={category.image}
        placeholder={ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_CATEGORY}
        onClick={this.onDisplayDetail}
      />
    );
  }

  render(): Object {
    const category:ProductCategory = this.props.category;

    return (
      <div className="category_row pointer row">
        <div
          className="hidden-xs col-sm-2"
          onClick={this.onDisplayDetail}
        >
          {this.renderImage()}
        </div>

        <div
          className="pointer col-xs-8 category_row__name"
          onClick={this.onDisplayDetail}
        >
          {category.name}
        </div>

        {/* <div
          className="pointer hidden-xs col-sm-4 category_row__description"
          onClick={this.onDisplayDetail}
          >
          {category.description}
        </div> */}

        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer text-center col-xs-1 category_row__delete"
            onClick={this.onDeleteCategoryFromRoot}
          >
            <i className="fa fa-trash" />
          </div>
        }

        {SecurityContext.restaurantMenu.canEdit() &&
          <div
            className="pointer text-center col-xs-1 category_row__drag"
          >
            <SortableList.DragHandle />
          </div>
        }

      </div>
    );
  }

}

export default CategoryRow;
